import { MediaLibrary } from '../media/MediaLibrary'
import { EMPTY_FIELD_VALUE } from './fieldValue'

/**
 * Les deux éditeurs de champ image du builder. Tous deux ouvrent LA même
 * médiathèque plein écran ; seule diffère la forme de ce qu'ils stockent.
 *
 * Ils sont déclarés `surface: 'fullscreen'` dans le registre : le
 * `FieldEditorPopover` les rend alors nus, sans son habillage de popover
 * ancré — la médiathèque porte son propre dialogue en portail.
 */

/**
 * `image-drupal` — la forme de référence : une RÉFÉRENCE au média.
 *
 * Seuls `{mid, alt}` sont persistés ; `url`/`width`/`height` et le descripteur
 * de recadrage (`src`/`scheme`/`cropBase`) partent avec pour que le canevas
 * affiche l'image immédiatement, puis sont écrasés — et retirés du stockage —
 * côté serveur (`OrbitDataEnricher`). Conséquence utile : remplacer le fichier
 * derrière un média met à jour toutes ses mises en page d'un coup.
 */
export const MediaEditor = ({ value, label, onSave, onClose }) => (
  <MediaLibrary
    value={value}
    title={label ? `Médiathèque — ${label}` : 'Médiathèque'}
    onClose={onClose}
    // Vider le champ. Ces deux éditeurs sont `surface: 'fullscreen'` : ils
    // court-circuitent le chrome du `FieldEditorPopover`, donc son bouton
    // « Vider » ne s'affiche jamais pour eux — la commande doit vivre ici.
    onClear={() => onSave(EMPTY_FIELD_VALUE)}
    onPick={(item) => onSave({
      mid: item.mid,
      alt: item.alt || undefined,
      url: item.url,
      width: item.width,
      height: item.height,
      src: item.src,
      scheme: item.scheme,
      cropBase: item.cropBase,
    })}
  />
)

/**
 * `image` — forme héritée : une URL nue.
 *
 * Les blocs qui la consomment posent un `<img src>` brut, donc rien ne peut y
 * recadrer à la volée. Elle reste servie par la médiathèque pour ne casser
 * aucune définition de bloc existante ; la faire passer en `image-drupal` +
 * `LazyImage` est ce qui lui donnerait le redimensionnement dynamique.
 */
export const MediaUrlEditor = ({ value, label, onSave, onClose }) => (
  <MediaLibrary
    value={value}
    title={label ? `Médiathèque — ${label}` : 'Médiathèque'}
    onClose={onClose}
    onClear={() => onSave(EMPTY_FIELD_VALUE)}
    onPick={(item) => onSave(item.url)}
  />
)
